/* YORK — Editorial v2 · interactions
   scroll reveal · header · marquee · tabs · counters · carousel · mobile nav · cart */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header state ---------- */
  var header = document.querySelector('.site-header');
  window.addEventListener('scroll', function () {
    if (header) header.classList.toggle('scrolled', window.scrollY > 30);
  }, { passive: true });

  /* ---------- Mobile nav ---------- */
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      document.body.classList.toggle('nav-open');
      var open = document.body.classList.contains('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.querySelectorAll('.mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('nav-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.fade-up').forEach(function (el) { io.observe(el); });

  /* ---------- Marquee: duplicate track for seamless loop ---------- */
  document.querySelectorAll('.marquee-track, .announce-mid').forEach(function (track) {
    if (track.dataset.cloned) return;
    track.innerHTML += track.innerHTML;
    track.dataset.cloned = '1';
  });

  /* ---------- Filtration tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('.filt-tab');
    var panels = group.querySelectorAll('.filt-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-target');
        tabs.forEach(function (t) { t.classList.remove('active'); });
        panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-panel') === target); });
        tab.classList.add('active');
      });
    });
  });

  /* ---------- Count-up metrics ---------- */
  function animateCount(el) {
    var target = parseFloat(el.dataset.count);
    var dec = (el.dataset.count.split('.')[1] || '').length;
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    if (reduce) { el.textContent = prefix + target.toFixed(dec) + suffix; return; }
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + (dec ? val.toFixed(dec) : Math.floor(val).toLocaleString()) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(dec).replace(/\.0+$/, '') + suffix;
    }
    requestAnimationFrame(step);
  }
  var countIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animateCount(e.target); countIO.unobserve(e.target); }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-count]').forEach(function (el) { countIO.observe(el); });

  /* ---------- Testimonials carousel ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('.testi-track');
    var cards = root.querySelectorAll('.testi-card');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track || !cards.length) return;
    var index = 0;
    function step() { return cards[0].getBoundingClientRect().width + 22; }
    function maxIndex() {
      var vw = root.querySelector('.testi-viewport').clientWidth;
      var per = Math.max(1, Math.floor(vw / step()));
      return Math.max(0, cards.length - per);
    }
    function go(i) {
      index = Math.max(0, Math.min(i, maxIndex()));
      track.style.transform = 'translateX(' + (-index * step()) + 'px)';
    }
    if (next) next.addEventListener('click', function () { go(index + 1); });
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    window.addEventListener('resize', function () { go(index); });
    // subtle auto-advance
    if (!reduce) {
      setInterval(function () { index = index >= maxIndex() ? 0 : index + 1; go(index); }, 6000);
    }
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product-gallery .main-image img');
      var src = thumb.dataset.full || (thumb.querySelector('img') && thumb.querySelector('img').src);
      if (main && src) main.src = src;
      document.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (!head) return;
    head.parentElement.classList.toggle('open');
  });

  /* ---------- Quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = btn.getAttribute('data-qty') === '+' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  /* ---------- Cart count + AJAX add ---------- */
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var el = document.querySelector('.cart-count');
      if (el) el.textContent = cart.item_count;
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.add-to-cart');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding\u2026'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartCount();
        if (btn) { btn.innerHTML = '\u2713 Added to cart'; setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1800); }
      })
      .catch(function () { if (btn) { btn.innerHTML = orig; btn.disabled = false; } form.submit(); });
  });
  refreshCartCount();

  /* ---------- Ensure looping videos play ---------- */
  document.querySelectorAll('video[autoplay]').forEach(function (v) {
    v.muted = true; v.playsInline = true;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  });
})();

/* ==================================================================
   v4 — live background, shop slideshow, gallery strip, transitions
   ================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Cursor glow: circular light with eased follow ---- */
  if (!reduce && window.matchMedia('(pointer:fine)').matches) {
    var glow = document.createElement('div');
    glow.className = 'cursor-glow';
    document.body.appendChild(glow);
    var tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    var cx = tx, cy = ty, raf = null, shown = false;
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!shown) { glow.classList.add('on'); shown = true; }
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
    document.addEventListener('mouseleave', function () { glow.classList.remove('on'); shown = false; });
    function tick() {
      cx += (tx - cx) * 0.11;
      cy += (ty - cy) * 0.11;
      glow.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      raf = (Math.abs(tx - cx) > 0.4 || Math.abs(ty - cy) > 0.4) ? requestAnimationFrame(tick) : null;
    }
  }

  /* ---- Product gallery strip: arrows + click to swap main image ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var strip = root.querySelector('.gallery-strip');
    var main = document.querySelector('.product-gallery .main-image img');
    if (!strip) return;
    var prev = root.querySelector('[data-gprev]'), next = root.querySelector('[data-gnext]');
    function step() {
      var first = strip.querySelector('.gshot');
      return first ? first.getBoundingClientRect().width + 12 : 260;
    }
    if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
    strip.querySelectorAll('.gshot').forEach(function (shot) {
      shot.addEventListener('click', function () {
        var full = shot.getAttribute('data-full');
        if (main && full) main.src = full;
        strip.querySelectorAll('.gshot').forEach(function (s) { s.style.borderColor = ''; });
        shot.style.borderColor = 'var(--aqua)';
      });
    });
  });

  /* ---- Soft page transition on internal navigation ---- */
  if (!reduce) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (a.hostname && a.hostname !== window.location.hostname) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      document.body.classList.add('is-leaving');
      setTimeout(function () { window.location.href = a.href; }, 220);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) document.body.classList.remove('is-leaving');
    });
  }

  /* ---- Localization selects auto-submit ---- */
  document.querySelectorAll('.loc-select select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var f = sel.closest('form');
      if (f) f.submit();
    });
  });
})();

/* ==================================================================
   v6 — smooth scroll, scroll-driven reveals, reliable slideshow
   ================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- SCROLL REVEALS ---------- */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (e.isIntersecting) {
        var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
        if (el._outT) { clearTimeout(el._outT); el._outT = null; }
        el._inT = setTimeout(function () { el.classList.add('revealed'); }, delay);
      } else if (el.hasAttribute('data-reveal-out')) {
        if (el._inT) { clearTimeout(el._inT); el._inT = null; }
        el._outT = setTimeout(function () { el.classList.remove('revealed'); }, 40);
      }
    });
  }, { threshold: 0.1, rootMargin: '-4% 0px -10% 0px' });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { revealIO.observe(el); });

  /* ---------- SPLIT-APART GROUPS ---------- */
  var splitIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('split-open'); splitIO.unobserve(e.target); }
    });
  }, { threshold: 0.22, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('[data-split-group]').forEach(function (el) { splitIO.observe(el); });

  /* ---------- PARALLAX ---------- */
  if (!reduce) {
    var pxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (pxEls.length) {
      var pxTick = false;
      function px() {
        var vh = window.innerHeight;
        pxEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var amt = parseFloat(el.getAttribute('data-parallax')) || 12;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          el.style.transform = 'translate3d(0,' + (-progress * amt).toFixed(2) + 'px,0)';
        });
        pxTick = false;
      }
      window.addEventListener('scroll', function () {
        if (!pxTick) { pxTick = true; requestAnimationFrame(px); }
      }, { passive: true });
      px();
    }
  }

  /* ---------- SHOP HERO SLIDESHOW ---------- */
  document.querySelectorAll('[data-shop-hero]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sh-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sh-dot]'));
    if (slides.length < 2) return;

    var i = 0, timer = null;
    var delay = parseInt(root.getAttribute('data-interval'), 10) || 7000;

    function show(n) {
      i = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('active', on);
        s.classList.remove('is-in');
        if (on) { void s.offsetWidth; s.classList.add('is-in'); }
      });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduce) return;
      timer = setInterval(function () { show(i + 1); }, delay);
    }
    function go(n) { show(n); start(); }

    root.querySelectorAll('[data-sh-next]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
    });
    root.querySelectorAll('[data-sh-prev]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function (e) { e.preventDefault(); go(k); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1)); else start();
      x0 = null;
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);   // always start on slide 1 (Smart)
    start();   // and start rotating immediately
  });
})();


/* ==================================================================
   YORK v12 — additions
   ================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Page loader ----------
     The CSS animation already retires the curtain on its own timer, so
     this is only here to take it down sooner once the page is actually
     ready. Belt and braces: a visitor must never be stuck behind it. */
  function clearLoader() { document.body.classList.add('yk-loaded'); }
  if (reduce) {
    clearLoader();
  } else {
    window.addEventListener('load', function () { setTimeout(clearLoader, 1650); });
    setTimeout(clearLoader, 4000);
  }

  /* ---------- Mega menu on touch ----------
     Hover opens it on a pointer device. On touch there is no hover, so
     the first tap on a mega parent opens the panel and the second tap
     follows the link. */
  var megaParents = document.querySelectorAll('.nav-links li.has-mega');
  var isTouch = window.matchMedia('(hover: none)').matches;

  if (isTouch) {
    megaParents.forEach(function (li) {
      var trigger = li.querySelector(':scope > a');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        if (!li.classList.contains('mega-open')) {
          e.preventDefault();
          megaParents.forEach(function (o) { if (o !== li) o.classList.remove('mega-open'); });
          li.classList.add('mega-open');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.has-mega')) {
        megaParents.forEach(function (li) { li.classList.remove('mega-open'); });
      }
    });
  }

  /* ---------- Escape closes the mobile panel and any open mega ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.body.classList.contains('nav-open')) {
      document.body.classList.remove('nav-open');
      document.body.style.overflow = '';
      var t = document.querySelector('.nav-toggle');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    }
    megaParents.forEach(function (li) { li.classList.remove('mega-open'); });
  });

  /* ---------- Plan buttons: keep the chosen term through the click ----------
     Purely cosmetic — marks the button as pressed so the transition to
     the product page does not look like a dead tap on a slow connection. */
  document.querySelectorAll('[data-plan-picker] .plan-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { btn.classList.add('is-loading'); });
  });
})();


/* ==================================================================
   YORK v12 — App journey flow
   ================================================================== */
(function () {
  'use strict';

  var tracks = document.querySelectorAll('[data-app-journey] .aj-track');
  if (!tracks.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce) {
    // Show the finished state immediately rather than animating it.
    tracks.forEach(function (t) {
      t.style.setProperty('--aj-progress', '1');
      t.querySelectorAll('.aj-node').forEach(function (n) { n.classList.add('is-lit'); });
    });
    return;
  }

  function update() {
    tracks.forEach(function (track) {
      var nodes = track.querySelectorAll('.aj-node');
      if (!nodes.length) return;

      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // The spine fills as the track crosses the lower two-thirds of the
      // viewport, so the line is always slightly ahead of what you read.
      var anchor = vh * 0.62;
      var progress = (anchor - rect.top) / rect.height;
      progress = Math.max(0, Math.min(1, progress));
      track.style.setProperty('--aj-progress', progress.toFixed(4));

      nodes.forEach(function (node) {
        var dot = node.querySelector('.aj-dot');
        var dotTop = dot ? dot.getBoundingClientRect().top : node.getBoundingClientRect().top;
        node.classList.toggle('is-lit', dotTop < anchor);
      });
    });
  }

  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { update(); queued = false; });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();


/* ==================================================================
   YORK v13 — Product purchase-plan switcher
   ==================================================================
   Selecting a plan now updates: price, was-price, the deposit /
   monthly / payments / total summary, the Add to cart state, the
   Buy it now target and label, the gallery image, and the address bar.

   The radios are named "id" inside the product form, so the correct
   variant is submitted even if this script never runs. Everything here
   is display only.
   ================================================================== */
(function () {
  'use strict';

  var dataEl = document.querySelector('[data-pp-data]');
  var plansEl = document.querySelector('[data-pp-plans]');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return; // malformed data: leave the server-rendered state alone
  }
  if (!variants || !variants.length) return;

  var $ = function (sel) { return document.querySelector(sel); };

  var priceEl   = $('[data-pp-price]');
  var wasEl     = $('[data-pp-was]');
  var detailEl  = $('[data-pp-detail]');
  var depositEl = $('[data-pp-deposit]');
  var monthlyEl = $('[data-pp-monthly]');
  var monthlyRw = $('[data-pp-monthly-row]');
  var countEl   = $('[data-pp-count]');
  var countRw   = $('[data-pp-count-row]');
  var totalEl   = $('[data-pp-total]');
  var totalRw   = $('[data-pp-total-row]');
  var addBtn    = $('[data-pp-add]');
  var buyBtn    = $('[data-pp-buynow]');
  var buyLabel  = $('[data-pp-buynow-label]');
  var mainImg   = document.getElementById('mainProductImage');

  var STR = {
    buyNow:    (buyLabel && buyLabel.dataset.buyNow) || 'Buy it now',
    startPlan: (buyLabel && buyLabel.dataset.startPlan) || 'Start this plan',
    add:       (addBtn && addBtn.dataset.add) || 'Add to cart',
    soldOut:   (addBtn && addBtn.dataset.soldOut) || 'Sold out'
  };
  // Read the labels the server already rendered, so translations survive.
  if (buyLabel) {
    var initial = buyLabel.textContent.trim();
    if (initial.indexOf('·') === -1) STR.buyNow = initial;
  }
  if (addBtn && !addBtn.disabled) STR.add = addBtn.textContent.trim();

  function show(el, on) { if (el) el.hidden = !on; }

  function apply(v) {
    if (!v) return;

    if (priceEl) priceEl.textContent = v.price;

    if (wasEl) {
      if (v.compare) { wasEl.textContent = v.compare; show(wasEl, true); }
      else { show(wasEl, false); }
    }

    var isPlan = !!v.term && v.term !== '0';
    show(detailEl, isPlan);

    if (depositEl) depositEl.textContent = v.price;
    if (monthlyEl) monthlyEl.textContent = v.monthly || '';
    show(monthlyRw, isPlan && !!v.monthly);
    if (countEl) countEl.textContent = v.count || '';
    show(countRw, isPlan && !!v.count);
    if (totalEl) totalEl.textContent = v.total || '';
    show(totalRw, isPlan && !!v.total);

    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? STR.add : STR.soldOut;
    }

    if (buyBtn) {
      show(buyBtn, v.available);
      buyBtn.setAttribute(
        'href',
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') .replace(/\/$/, '') + '/cart/' + v.id + ':1'
      );
      if (buyLabel) {
        buyLabel.textContent = isPlan
          ? STR.startPlan + ' · ' + v.price
          : STR.buyNow;
      }
    }

    if (mainImg && v.image) mainImg.setAttribute('src', v.image);

    // Keep the address bar on the selected variant so the page can be
    // shared, reloaded or bookmarked on the plan the shopper chose.
    if (v.url && window.history && window.history.replaceState) {
      try { window.history.replaceState({}, '', v.url); } catch (e) { /* ignore */ }
    }
  }

  function byId(id) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  document.querySelectorAll('[data-pp-radio]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      document.querySelectorAll('.pp-plan').forEach(function (l) { l.classList.remove('is-on'); });
      var label = radio.closest('.pp-plan');
      if (label) label.classList.add('is-on');
      apply(byId(radio.value));
    });
  });

  // Honour ?variant= on load, in case the shopper arrived from a plan
  // button elsewhere on the site.
  var qv = new URLSearchParams(window.location.search).get('variant');
  if (qv) {
    var target = document.querySelector('[data-pp-radio][value="' + qv + '"]');
    if (target && !target.disabled && !target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
})();


/* ==================================================================
   YORK v15 — agreement gate, cart quantities
   ================================================================== */
(function () {
  'use strict';

  /* ---------- Acceptance gate ----------
     Enables the buy / checkout controls once every box in the gate is
     ticked. A courtesy gate, not a security control — the agreement of
     record is the signed document your team emails out. */
  document.querySelectorAll('[data-agree-gate]').forEach(function (gate) {
    var boxes = gate.querySelectorAll('[data-agree-check]');
    var warn = gate.querySelector('[data-agree-warn]');
    var targets = document.querySelectorAll('[data-agree-target]');
    if (!boxes.length || !targets.length) return;

    function sync() {
      var ok = true;
      boxes.forEach(function (b) { if (!b.checked) ok = false; });
      targets.forEach(function (t) {
        if (t.tagName === 'BUTTON' || t.tagName === 'INPUT') {
          t.disabled = !ok;
        } else {
          // anchor: keep it visible but inert until accepted
          t.classList.toggle('is-locked', !ok);
          t.setAttribute('aria-disabled', ok ? 'false' : 'true');
        }
      });
      if (warn) warn.hidden = ok;
    }

    boxes.forEach(function (b) { b.addEventListener('change', sync); });

    // Anchors cannot be disabled, so stop the click while locked.
    targets.forEach(function (t) {
      if (t.tagName === 'A') {
        t.addEventListener('click', function (e) {
          if (t.classList.contains('is-locked')) {
            e.preventDefault();
            if (warn) { warn.hidden = false; }
            gate.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      }
    });

    sync();
  });

  /* ---------- Cart quantity steppers ----------
     The inputs are named updates[] so the cart form handles them with or
     without this script; pressing + or - just saves a trip to Update. */
  document.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-cart-input]');
    if (!input) return;

    function step(by) {
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 1;
      n = Math.max(0, n + by);
      input.value = n;
      var form = input.closest('form');
      if (form) form.submit();
    }

    var minus = wrap.querySelector('[data-cart-minus]');
    var plus = wrap.querySelector('[data-cart-plus]');
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });

    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();


/* ==================================================================
   YORK v22 — Smart Monitoring live app panels (snippets/app-screens.liquid)
   ==================================================================
   Dropdowns and filter rows open and close; chart lines switch on and
   off (one always stays on); the sun/moon button swaps the app's dark
   and light modes; on phones the three panels are tabs. The ring, bars
   and numbers fill once the section is on screen, after the page
   loader. Without this script every panel and dropdown is shown open.
   ================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-amx]');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('is-ready');

  // Dropdowns (water quality) and filter rows
  root.querySelectorAll('.amx-head').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('.amx-row');
      if (!row) return;
      var open = !row.classList.contains('is-open');
      row.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Chart lines
  var chart = root.querySelector('.amx-chart');
  var keys = [].slice.call(root.querySelectorAll('[data-amx-line]'));
  keys.forEach(function (key) {
    key.addEventListener('click', function () {
      var on = key.getAttribute('aria-pressed') !== 'true';
      if (!on && !keys.some(function (k) { return k !== key && k.getAttribute('aria-pressed') === 'true'; })) return;
      key.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (chart) chart.setAttribute('data-show-' + key.getAttribute('data-amx-line'), on ? '1' : '0');
    });
  });

  // Dark / light, like the app's own switch
  var mode = root.querySelector('[data-amx-mode]');
  if (mode) {
    mode.addEventListener('click', function () {
      var light = root.getAttribute('data-mode') !== 'light';
      root.setAttribute('data-mode', light ? 'light' : 'dark');
      mode.setAttribute('aria-label', mode.getAttribute(light ? 'data-label-dark' : 'data-label-light') || '');
    });
  }

  // Phones: the three panels as tabs
  var tabs = [].slice.call(root.querySelectorAll('[data-amx-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-amx-panel]'));
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var want = tab.getAttribute('data-amx-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-amx-panel') === want;
        p.classList.toggle('is-tab', on);
        if (on) p.classList.add('revealed'); // shown by the tab, so skip the scroll reveal
      });
    });
  });

  // Numbers count up with the ring
  var counters = [].slice.call(root.querySelectorAll('[data-amx-count]'));
  function countUp() {
    counters.forEach(function (el) {
      var to = parseInt(el.getAttribute('data-amx-count'), 10) || 0;
      if (reduce) { el.textContent = to; return; }
      var t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / 1400);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  var loader = document.querySelector('.yk-loader');
  var loading = !!loader && !document.body.classList.contains('yk-loaded');
  if (!reduce && loading) counters.forEach(function (el) { el.textContent = '0'; });

  var entered = false;
  function enter() {
    if (entered) return;
    entered = true;
    setTimeout(function () { root.classList.add('is-in'); if (!reduce && loading) countUp(); }, loading && !reduce ? 1100 : 0);
  }
  if (reduce || !loading) { root.classList.add('is-in'); entered = true; }

  if (!entered && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { enter(); io.disconnect(); }
    }, { threshold: 0.15 });
    io.observe(root);
  } else {
    enter();
  }
})();
